import { crayon } from 'oderon-vue/utils'
import { preProcessSpec } from 'oderon-commons/src/tables'
import { brDateTime } from 'oderon-commons/src/formatters'

export const fullSpec = preProcessSpec({
  defCodes: ['id', 'email', 'fullName', 'tags', 'comments'],
  columns: [
    {
      t: 'ID|',
      d: 'id',
      f: crayon.grey,
      w: 100,
      selectable: true,
      sortable: true
    },
    {
      t: '|Email',
      d: 'email',
      selectable: true,
      sortable: true,
      w: 350
    },
    {
      t: 'Tipo',
      d: 'type',
      selectable: true,
      sortable: true,
      w: 200
    },
    {
      t: 'Nome',
      d: 'fullName',
      selectable: true,
      sortable: true,
      w: 250
    },
    {
      t: 'URL padrão',
      d: 'nextUrl',
      selectable: true,
      sortable: true
    },
    {
      t: 'Apps',
      d: 'allowedApps',
      selectable: true,
      sortable: true
    },
    {
      t: 'Tags',
      d: 'tags',
      selectable: true,
      sortable: true
    },
    {
      t: 'Atualizado em|',
      d: 'updatedAt',
      selectable: true,
      sortable: true,
      f: brDateTime
    },
    {
      t: 'Desligado em|',
      d: 'endedAt',
      selectable: true,
      sortable: true,
      f: brDateTime
    },
    {
      t: 'Senha definida em|',
      d: 'pwUpdatedAt',
      selectable: true,
      sortable: true,
      f: brDateTime
    },
    {
      t: '|Comentários',
      d: 'comments',
      selectable: true,
      sortable: true
    }
  ]
})
